export default __webpack_public_path__ + "static/media/meal.847e3464.mp4";